// extracted by css-extract-rspack-plugin
export default {"tabs":"tabs-ONZYCm"};